import { render, staticRenderFns } from "./GuestsInfoCard.vue?vue&type=template&id=0d1e607e&"
import script from "./GuestsInfoCard.vue?vue&type=script&lang=js&"
export * from "./GuestsInfoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports